import { isValidElement, type ReactElement, useId } from 'react'
import { type DataTestIdAttribute, type HTMLAttributesWithoutStyling } from '../../types'
import { Body1, Body2 } from '../../primitives/Typography'
import { Box } from '../../primitives/Box'

export type DescriptionListItemProps = {
  title: string
  description: string | ReactElement
  /**
   * Our details or secondary text alongside the title, same as title we prefer string but we can also use ReactElement for more complex cases
   *
   * @default '-'
   */
} & DataTestIdAttribute &
  HTMLAttributesWithoutStyling<HTMLDListElement>

/**
 * DescriptionListItem
 *
 * Demos:
 * - [DescriptionListItem](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/story/constructs-descriptionlist--list-item)
 *
 */

export const DescriptionListItem = ({ title, description, ...props }: DescriptionListItemProps) => {
  const id = useId()

  return (
    <>
      <Box role="term" id={id} component="dt" {...props} sx={{ wordBreak: 'break-word' }}>
        <Body2 variant="tertiary">{title}</Body2>
      </Box>
      <Box role="definition" aria-labelledby={id} component="dd" sx={{ m: 0, wordBreak: 'break-word' }}>
        {!isValidElement(description) ? <Body1>{description || '-'}</Body1> : description}
      </Box>
    </>
  )
}
